import script from "./CategoryParentTreeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryParentTreeList.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryParentTreeList.vue?vue&type=style&index=0&id=31d9da7e&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d9da7e"]])

export default __exports__